import styled from "styled-components";

export const Wrapper = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  font-family: "OpenSansRegular";
  font-weight: 400;
  font-size: 16px;
  width: 100%;
  height: 50px;
  padding-left: 52px;
  box-sizing: border-box;
  @media (max-width: 1400px) {
    width: 390px;
    padding-left: 0px;
  }
`;
